import React, { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { FaCcStripe } from "react-icons/fa";

import "./Sidebar.css";
import logo from "../images/logo.png";
import {
  CircleDollarSignIcon,
  LayoutDashboardIcon,
  LayoutIcon,
  PanelLeftOpenIcon,
  User2Icon,
  NotepadTextIcon,
  GanttChartSquareIcon,
} from "lucide-react";

const SidebarData = [
  {
    name: "Dashboard",
    to: "/dashboard",
    icon: <LayoutDashboardIcon />,
  },
  {
    name: "Users",
    to: "/users",
    icon: <User2Icon />,
  },
  {
    name: "Websites",
    to: "/websites",
    icon: <LayoutIcon />,
  },
  {
    name: "Payments",
    to: "/payments",
    icon: <CircleDollarSignIcon />,
  },
  // {
  //   name: "Pricing",
  //   to: "/plan",
  //   icon: <GanttChartSquareIcon />,
  // },
  // {
  //   name: "Stripe",
  //   to: "/stripe",
  //   icon: <FaCcStripe size={20} />,
  // },
];

const Sidebar = () => {
  const [open, setOpen] = useState(false);
  const [hoveredIndex, setHoveredIndex] = useState(null);

  const navigate = useNavigate();

  return (
    <div
      className={`bg-white  h-screen border-r-2 shadow-sm	 border-gray-200 py-7 sticky top-0 z-50 hidden 2xl:block xl:block lg:block  ${
        open
          ? "w-[240px] transition-all duration-200"
          : "w-20 transition-all duration-300"
      }`}
    >
      <aside>
        <div
          className={`flex items-center px-5  ${
            open ? "justify-between flex-row" : "justify-center flex-col"
          }`}
        >
          <div
            className={` ${
              open ? "block" : "hidden transition-all duration-300"
            }`}
          >
            {/* <img src={logo} width="100%" height="100%" alt="logo" /> */}
            {/* <p className="font-semibold tracking-normal antialiased">
              SEO Insights
            </p> */}
          </div>

          <div
            onClick={() => setOpen((prev) => !prev)}
            className="hover:text-indigo-400 cursor-pointer hover:transition-all hover:duration-300 hover:bg-gray-100 p-2 rounded-full transition-all duration-300"
          >
            <PanelLeftOpenIcon />
          </div>
        </div>

        <div className="mt-6">
          {SidebarData.map((item, index) => (
            <NavLink
              key={index}
              to={item.to}
              className={`flex py-5 items-center group${
                open
                  ? " hover:bg-gray-100 hover:rounded-[8px] hover:transition-all hover:duration-300 cursor-pointer group mb-4"
                  : "justify-center px-5 "
              }`}
              onMouseEnter={() => setHoveredIndex(index)}
              onMouseLeave={() => setHoveredIndex(null)}
              activeClassName="active"
            >
              <p
                className={` ${
                  !open
                    ? `rounded-full  p-2  cursor-pointer hover:transition-all hover:duration-300 ${
                        hoveredIndex === index
                          ? "text-indigo-400 bg-gray-100 scale-110"
                          : "hover:text-indigo-400 hover:bg-gray-100"
                      }`
                    : "px-5 "
                }  ${
                  open && hoveredIndex === index
                    ? "text-indigo-400 transition-all duration-300 "
                    : ""
                }`}
              >
                {item.icon}
              </p>
              {hoveredIndex === index && !open && (
                <div className="bg-indigo-100 ml-2 p-1.5 rounded-[8px] transition-all duration-300 shadow-sm border border-gray-100">
                  <p className="w-[80px] text-center antialiased tracking-normal">
                    {item.name}
                  </p>
                </div>
              )}
              <p className={`${open ? "block" : "hidden"}`}>{item.name}</p>
            </NavLink>
          ))}
        </div>
      </aside>
    </div>
  );
};

export default Sidebar;
